import { useEffect, useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthProvider";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

const StatusbarComponent = () => {
    const [currenttime, setCurrenttime] = useState();
    const [connected, setConnected] = useState(false);

    const { setAuth } = useContext(AuthContext);
    const navigate = useNavigate();
    const eventSourceRef = useRef(null);

    useEffect(() => {
        // const eventSource = new EventSource('https://logboek.vdlsoft.nl/api/currenttime');
        // const eventSource = new EventSource('http://localhost:3030/api/v1/notifications/currenttime');
        eventSourceRef.current = new EventSource('https://www.vdlsoft.nl/api/v1/notifications/currenttime');
        // const eventSource = new EventSource('/api/currenttime');

        eventSourceRef.current.onmessage = event => {
            setCurrenttime(event.data);
            setConnected(true);
        };

        eventSourceRef.current.onerror = err => {
            console.error("SSE error:", err);
            setConnected(false);
            eventSourceRef.current.close();
        };

        return () => eventSourceRef.current?.close();
    }, []);

    const handleLogout = () => {
        // Close SSE connection
        eventSourceRef.current?.close();

        // Clear auth state (this also clears localStorage automatically)
        setAuth({});

        // Redirect to login
        navigate("/logout");
    };

    return (
        <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center py-2">
                <div>
                    <span id="time">{currenttime}</span>
                </div>

                <div className="d-flex align-items-center gap-3">
                    <span>
                        Status: {connected ? "🟢 Connected" : "🔴 Disconnected"}
                    </span>

                    <button
                        className="btn btn-sm btn-link p-0 d-flex align-items-center fs-5" title="log-out"
                        onClick={handleLogout}
                    >
                        <FontAwesomeIcon icon={faSignOutAlt} style={{ color: "#000", transform: "translateY(-8px)" }}/>
                    </button>
                </div>
            </div>
        </div>
    )
}

export { StatusbarComponent };